import React from 'react';
import { Link } from 'react-router-dom';
import 'react-toggle/style.css';
import Toggle from 'react-toggle';
import { useSelector } from 'react-redux';

//Função que mapeia objeto de filiais e renderiza tds
export default function Motives({ motives }) {
    const perfis = useSelector(state => state.auth.user.perfis) || [];
    const motive = motives || [];
    return motive.map(desc => (
        <tr key={desc.id}>
            <td>{desc.descricao}</td>
            <td>
                <ul className='nav'>
                    <li className='nav-item dropdown'>
                        <a className='nav-link' data-toggle='dropdown' href='#/'>
                            <i className='fas fa-ellipsis-h' />
                        </a>
                        <div className='dropdown-menu dropdown-menu-right'>
                            <Link
                                to={`/motive/${desc.id}/view`}
                                className='dropdown-item'
                            >
                                <i className='fas fa-eye'></i> Detalhes
                            </Link>
                            {
                                perfis.indexOf(1) >= 0 || perfis.indexOf(2) >= 0 || perfis.indexOf(3) >= 0 || perfis.indexOf(6) >= 0 || perfis.indexOf(10) >= 0 || perfis.indexOf(13) >= 0 ? (
                                    <>
                                        <Link
                                            to={`/motive/${desc.id}/edit`}
                                            className='dropdown-item'
                                        >
                                            <i className='fas fa-edit'></i> Editar
                                        </Link>
                                    </>
                                ) : ''
                            }
                        </div>
                    </li>
                </ul>
            </td>
        </tr>
    ));

}
